export default {
      ProductColors: '$MHF_ModelNameVal_$MHF|ProductColors',

};
